
import { defineComponent, ref } from "vue";
import PopulationChart from "@/components/PopulationChart.vue";
import ReproductionChart from "@/components/ReproductionChart.vue";
import PopulationExperimentChart from "@/components/PopulationExperimentChart.vue";
import ReproductionExperimentChart from "@/components/ReproductionExperimentChart.vue";
import MasksChart from "@/charts/MasksChart.vue";
import { IOptions } from "@/utils/types";
import { useSimulation } from '@/hooks/useSimulation';
import router from '@/router';

export default defineComponent({
  components: {
    PopulationChart,
    ReproductionChart,
    PopulationExperimentChart,
    ReproductionExperimentChart,
    MasksChart
  },
  props: {
    name: {
      type: String,
      required: true
    },
    options: {
      required: true
    }
  },
  setup(props) {
    const model = ref<any>(props.name)

    const switchModel = (event: any) => {
      router.replace(event.target.value)
    }

    const openGitHub = () => {
      window.open('https://github.com/troykessler/covid-simulation', '_blank')
    }

    return {
      model,
      switchModel,
      openGitHub,
      ...useSimulation(`simulation-window-${props.name}`, props.options as IOptions)
    };
  },
});
